export const authConstants = {
  LOGIN: "LOGIN",
  UPDATE_CURRENT_USER: "UPDATE_CURRENT_USER",
  FORGOT: "FORGOT",
  RESET: "RESET",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  REGISTER: "REGISTER",
  AGENT_REGISTRATION: "AGENT_REGISTRATION",
  VERIFY_EMAIL: "VERIFY_EMAIL",
  UPDATE_USER_ROLE: "UPDATE_USER_ROLE",
  IS_NAVIGATE_TO_DEFAULT: "IS_NAVIGATE_TO_DEFAULT",
  IS_AUTH_MODAL_OPEN: "IS_AUTH_MODAL_OPEN",
};

export const API_STATUS = {
  SUCCESS: 0,
  FAIL: 1,
};

export const FORM_SLIDE = {
  COMPANY_INFORAMTION: 1,
  COMPANY_HOURS: 2,
  AGENT_INFORMATION: 3,
  EMERGENCY_CONTACT: 4,
};

export const SLIDE_DIRECTION = {
  NEXT: "next",
  PREVIOUS: "previous",
};

export const SELECT_FORM_SLIDE = {
  1: "company",
  2: "officeHours",
  3: "agent",
  4: ["emergencyContactInfo", "document"],
};

export const defaultSchedule = [
  {
    id: 1,
    name: "Monday",
    isActive: false,
    startTime: "00:00",
    endTime: "23:59",
    endTimeError: null,
    startTimeError: null,
  },
  {
    id: 2,
    name: "Tuesday",
    isActive: false,
    startTime: "00:00",
    endTime: "23:59",
    endTimeError: null,
    startTimeError: null,
  },
  {
    id: 3,
    name: "Wednesday",
    isActive: false,
    startTime: "00:00",
    endTime: "23:59",
    endTimeError: null,
    startTimeError: null,
  },
  {
    id: 4,
    name: "Thursday",
    isActive: false,
    startTime: "00:00",
    endTime: "23:59",
    endTimeError: null,
    startTimeError: null,
  },
  {
    id: 5,
    name: "Friday",
    isActive: false,
    startTime: "00:00",
    endTime: "23:59",
    endTimeError: null,
    startTimeError: null,
  },
  {
    id: 6,
    name: "Saturday",
    isActive: false,
    startTime: "00:00",
    endTime: "23:59",
    endTimeError: null,
    startTimeError: null,
  },
  {
    id: 7,
    name: "Sunday",
    isActive: false,
    startTime: "00:00",
    endTime: "23:59",
    endTimeError: null,
    startTimeError: null,
  },
];

export const preferredContactMethod = [
  { id: 1, name: "Email" },
  { id: 2, name: "Phone Number" },
];

export const TIME_FIELD = {
  START: "startTime",
  END: "endTime",
};

export const TIME_ERROR_MESSAGE = {
  START_RANGE: "Start time must be (00:00 - 23:59)",
  END_RANGE: "End time must be (00:00 - 23:59)",
  START_INVALID: "Start time must be earlier than end time",
  END_INVALID: "End time must be later than start time",
};

export const AGENT_REGISTRATION_MESSAGE =
  "Thanks for registering with us, please re-login to apply the changes.";
